<template>
  <div class="container">
    <BaseFrame
      :idText = 'idText'
      :id="id"
      :infosArr="infosArr"
      :able="able"
      @cancel='$router.push(-1)'
      submitText="提交"
      @submit='submit("recallForm.saleRecallPlan")'
      saveText='保存'
      clearText=""
      @save='save("recallForm.saleRecallPlan")'
      @setAble="setAble"
      :logText="logText"
      @hanldeLog="handleLog"
      :logData="logData"
    >
      <div slot="content">
        <lk-form
          :model="recallForm.saleRecallPlan"
          label-position="right"
          :label-width="130"
          ref="recallForm.saleRecallPlan"
          :rules="ruleValidate"
        >
          <div class="cardContainer">
            <lk-card title="召回计划信息">
              <lk-row :gutter="16">
                <lk-col span="10">
                  <lk-form-item label="召回机构:" prop="supplierStoreId">
                    <SupplierListSelect v-if="able" v-model.trim="recallForm.saleRecallPlan.supplierStoreId"></SupplierListSelect>
                    <span v-else>{{recallForm.saleRecallPlan.recallAgency}}</span>
                  </lk-form-item>
                </lk-col>

              </lk-row>
              <lk-row :gutter="16">
                <lk-col span="10">
                  <lk-form-item label="召回原因:" prop="recallReason">
                    <lk-input :maxlength='100' placeholder='请输入' clearable v-if="able"
                              type="textarea" v-model.trim="recallForm.saleRecallPlan.recallReason"></lk-input>
                    <span v-else v-html="brRecallReason"></span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                 <lk-col span="10">
                  <lk-form-item label="召回凭据:" v-if="this.$route.name === 'medicineRecallCheck' ">
                    <span v-if="!(recallForm.saleRecallPlan.recallImgUrl)"></span>
                    <Uploader v-else style="width:250px" :able='false' v-model.trim="recallForm.saleRecallPlan.recallImgUrl" :format="imgFormat"></Uploader>
                  </lk-form-item>
                  <lk-form-item v-else label="召回凭据:" prop="recallImgUrl">
                    <Uploader style="width:250px" :able='true' v-model.trim="recallForm.saleRecallPlan.recallImgUrl" :format="imgFormat"></Uploader>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16">
                <lk-col>
                  <lk-form-item label="召回商品:">
                    <div class='mb16' v-if="able">
                      <lk-button type='primary' @click="handleAdd">新增</lk-button>
                    </div>
                    <div class="goodsTable">
                      <lk-table border :columns='columns' :data='tableData'></lk-table>
                    </div>
                  </lk-form-item>
                </lk-col>
              </lk-row>

              <!--<lk-row :gutter="16">-->
                <!--<lk-col span="10">-->
                  <!--<lk-form-item label="备注:" prop="type">-->
                    <!--<lk-input :maxlength='100' placeholder='请输入' v-if="able"></lk-input>-->
                    <!--<span v-else></span>-->
                  <!--</lk-form-item>-->
                <!--</lk-col>-->
              <!--</lk-row>-->
            </lk-card>
          </div>

          <!--    -->
        </lk-form>
      </div>
    </BaseFrame>

    <lk-modal width='800' v-model="showModal" title="召回商品" :mask-closable='false'>
      <div class="queryContainer">
        <div class="queryItem">
          <label>通用名称:</label>
          <lk-input :maxlength="100" placeholder="请输入" class="item" v-model.trim="modalQueryParams.approvedName"></lk-input>
        </div>
        <div class="queryItem">
          <label>生产企业:</label>
          <lk-input :maxlength="100" placeholder="请输入" class="item" v-model.trim="modalQueryParams.manufacturer"></lk-input>
        </div>
        <div class="queryItem">
          <label class="requireStar">批号:</label>
          <lk-input :maxlength="100" placeholder="请输入" class="item" v-model.trim="modalQueryParams.goodsBatchNumber"></lk-input>
        </div>
        <div class="queryItem">
          <lk-button class="mr8" type='primary' @click="handleSearch">查询</lk-button>
          <lk-button class="mr8" @click="clearModalQuery">重置</lk-button>
        </div>
      </div>

      <div class="addContainer">
        <lk-table @on-selection-change='handleSelect' border :columns='modalColumns' :data='modalTableData'></lk-table>
      </div>
      <div style="text-align:right;padding-top:15px;">
        <lk-page :total="count" size="small" show-sizer show-elevator @on-change='handlePage' @on-page-size-change='handleSize'></lk-page>
      </div>
      <div slot="footer">
        <div class="modalFooter">
          <span class="mr8">已选：{{tempModalSelection.length}}项</span>
          <lk-button @click="clearModal">取消</lk-button>
          <lk-button type='primary' @click="pushData">确定</lk-button>
        </div>
      </div>
    </lk-modal>
  </div>
</template>

<script>
import BaseFrame from '../../components/frame/BaseFrame.vue';
import afterSale from '../../services/afterSale';
import utils from '../../libs/utils';
import SupplierListSelect from '../../components/SupplierListSelect.vue';
import Uploader from '../../components/Uploader.vue';
export default {
  name: 'MedicineRecallInfo',
  components: {
    BaseFrame,
    SupplierListSelect,
    Uploader
  },
  data() {
    const validateImg = (rule,value,callback) => {
        if(value === '') {
          callback(new Error('请上传图片'));
        } else {
          callback();
        }
    }
    return {
      imgFormat: ['jpg', 'jpeg', 'gif', 'png', 'tiff', 'bmp'],
      imgUrl: '',
      idText: '召回单号',
      id: '',
      logText: '',
      infosArr: [],
      showClear: false,
      able: true,
      showModal: false,
      goodsError: true,
      modalSelection: [],
      tempModalSelection: [],
      tempGoodsStoreId: '',
      // selectedIds: [],
      modalQueryParams: {
        approvedName: '',
        manufacturer: '',
        goodsBatchNumber: '',
      },
      logData: [],
      logPage: 1,
      logSize: 10,
      logCount: 0,
      logParams: {
        recallPlanId: '',
      },
      page: 1,
      size: 10,
      count: 0,
      recallPlanStatus: '', // 召回审批状态
      recallForm: {
        saleRecallPlan: {
          id: '', // 召回计划id
          recallReason: '', // 召回原因
          recallAgency: '', // 召回机构
          recallImgUrl: '', //召回凭据
          drugApprovedNames: '', // 通用名称
          drugSerialCode: '', // 商品编码
          specifications: '', // 规格
          licenseNumber: '', // 批准文号
          manufacturer: '', // 生产企业
          supplierStoreId: null, // 供应商id
          goodsStoreId: '',
        },
        saleRecallPlanInfoVOS: [],
      },

      columns: [
        {
          title: '序号', key: 'index', width: 80, type: 'index',
        },
        {
          title: '单据来源',
          key: 'revokedTypeEnum',
          minWidth: 116,
          render: (h, params) => {
            if (params.row.revokedTypeEnum === 1) {
              return h('span', '库存商品');
            } if (params.row.revokedTypeEnum === 2) {
              return h('span', '销售订单');
            } if (params.row.revokedTypeEnum === 3) {
              return h('span', '调拨单');
            }
            return h('span', '-');
          },
        },
        { title: '单号', key: 'itemId', minWidth: 116 },
        { title: '通用名称', key: 'drugApprovedNames', minWidth: 116 },
        { title: '规格', key: 'specifications', minWidth: 116 },
        { title: '批号', key: 'goodsBatchNumber', minWidth: 116 },
        { title: '生产厂家', key: 'manufacturer', minWidth: 116 },
        { title: '数量', key: 'itemCount', minWidth: 116 },
        {
          title: '操作',
          key: 'addBtn',
          minWidth: 100,
          fixed: 'right',
          render: (h, params) => h('div', [
            h('lk-button', {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  const index = params.row._index;
                  this.tableData.splice(index, 1);
                  this.recallForm.saleRecallPlanInfoVOS.splice(index, 1);
                  this.selectedIds.splice(index, 1);
                },
              },
            }, '删除'),
          ]),
        },
      ],
      tableData: [],
      modalColumns: [
        {
          title: '选择', type: 'selection', width: 60,
        },
        {
          title: '单据来源',
          key: 'revokedTypeEnum',
          minWidth: 116,
          render: (h, params) => {
            if (params.row.revokedTypeEnum === 1) {
              return h('span', '库存商品');
            } if (params.row.revokedTypeEnum === 2) {
              return h('span', '销售订单');
            } if (params.row.revokedTypeEnum === 3) {
              return h('span', '调拨单');
            }
            return h('span', '-');
          },
        },
        { title: '单号', key: 'itemId', minWidth: 116 },
        { title: '通用名称', key: 'drugApprovedNames', minWidth: 116 },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 116 },
        { title: '规格', key: 'specifications', minWidth: 116 },
        { title: '批号', key: 'goodsBatchNumber', minWidth: 116 },
        { title: '数量', key: 'itemCount', minWidth: 116 },
        { title: '生产厂家', key: 'manufacturer', minWidth: 116 },
      ],
      modalTableData: [],
      ruleValidate: {
        supplierStoreId: [
          {
            required: true, message: '请选择召回机构', trigger: 'change', type: 'number',
          },
        ],
        recallReason: [
          { required: true, message: '请输入召回原因', trigger: 'blur' },
        ],
        recallImgUrl: [
          { required: true, validator: validateImg, trigger: 'change'},
        ]
      },
    };
  },
  computed: {
    selectedIds() {
      const result = [];
      this.tableData.forEach((item) => {
        result.push(item.itemId);
      });
      return result;
    },
    brRecallReason() {
      const reg = new RegExp('\\n', 'g');// g,表示全部替换。
      return this.recallForm.saleRecallPlan.recallReason.replace(reg, '<br/>');
    },
    recallAgencyList() {
      return this.$store.state.user.supplierList;
    },
  },
  methods: {
    submit(name) { // 提交召回计划
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.recallForm.saleRecallPlanInfoVOS && this.recallForm.saleRecallPlanInfoVOS.length > 0) {
            this.selectDiffGoods();
            if (this.goodsError) {
              this.recallAgencyList.forEach((supplier) => {
                const item = supplier.outerPassInfo || supplier;
                if (item.id === this.recallForm.saleRecallPlan.supplierStoreId) {
                  this.recallForm.saleRecallPlan.recallAgency = item.name;
                }
              });

              afterSale.recallPlanSubmit(this.recallForm).then((res) => {
                if (res.data.status === 200) {
                  this.$Message.success('提交成功');
                  setTimeout(() => {
                    this.$router.go(-1);
                  }, 1000);
                } else {
                  this.$Message.error(res.data.error);
                }
              }).catch((err) => {
                utils.handleError(err);
              });
            } else {
              this.$Message.error('存在不同的商品，请分开提交!');
            }
          } else {
            this.$Message.error('请选择召回商品!');
          }
        } else {
          this.$Message.error('请按照要求填写!');
        }
      });
    },
    save(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.recallForm.saleRecallPlanInfoVOS && this.recallForm.saleRecallPlanInfoVOS.length > 0) {
            // console.log('**************');
            // console.log(this.goodsError);
            this.selectDiffGoods();
            if (this.goodsError) {
              this.recallAgencyList.forEach((supplier) => {
                const item = supplier.outerPassInfo || supplier;
                if (item.id === this.recallForm.saleRecallPlan.supplierStoreId) {
                  this.recallForm.saleRecallPlan.recallAgency = item.name;
                }
              });

              if (this.$route.name === 'medicineRecallEdit') {
                afterSale.recallPlanUpdate(this.recallForm).then((res) => {
                  if (res.data.status === 200) {
                    this.$Message.success('保存成功');
                    setTimeout(() => {
                      this.$router.go(-1);
                    }, 1000);
                  } else {
                    this.$Message.error(res.data.error);
                  }
                }).catch((err) => {
                  utils.handleError(err);
                });
              } else {
                // console.log(this.roleForm);
                afterSale.recallPlanCreate(this.recallForm).then((res) => {
                  if (res.data.status === 200) {
                    this.$Message.success('保存成功');
                    setTimeout(() => {
                      this.$router.go(-1);
                    }, 1000);
                  } else {
                    this.$Message.error(res.data.error);
                  }
                }).catch((err) => {
                  utils.handleError(err);
                });
              }
            } else {
              this.$Message.error('存在不同的商品，请分开提交!');
            }
          } else {
            this.$Message.error('请选择召回商品!');
          }
        } else {
          this.$Message.error('请按照要求填写!');
        }
      });
    },
    setAble(val) { // frame判定框架是否支持录入
      this.able = val;
      if (!this.able) {
        this.$set(this.ruleValidate, null);
        this.ruleValidate = null;
      }
    },
    handleAdd() {
      if (this.recallForm.saleRecallPlan.supplierStoreId === '') {
        this.$Message.error('请选择召回机构');
      } else {
        this.showModal = true;
        this.modalQueryParams = {};
        this.modalTableData = [];
        this.count = 0;
        this.recallForm.saleRecallPlanInfoVOS = [];
        // this.getRecallGoods();
      }
    },
    getRecallGoods() {
      this.modalQueryParams.page = this.page;
      this.modalQueryParams.size = this.size;
      const params = Object.assign({}, this.modalQueryParams);
      params.supplierStoreId = this.recallForm.saleRecallPlan.supplierStoreId;
      afterSale.recallPlanGoodsList(params).then((res) => {
        if (res.data.status === 200) {
          // console.log('------------选中召回商品--------');
          // console.log(this.selectedIds);
          this.modalTableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result._checked = this.selectedIds.includes(result.itemId);
            result._disabled = this.selectedIds.includes(result.itemId);
            this.modalTableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    clearModalQuery() {
      // this.modalSelection = [];
      this.modalQueryParams = {};
    },
    handleSelect(selection) {
      // this.modalSelection = selection;

      // console.log(selection);
      this.tempModalSelection = utils.deepClone(this.tableData);
      selection.forEach((item) => {
        if (!this.selectedIds.includes(item.itemId)) {
          this.tempModalSelection.push(item);
        }
      });
    },
    clearModal() {
      this.hideModal();
      this.clearModalQuery();
      this.modalTableData = [];
    },
    hideModal() {
      this.showModal = false;
    },
    pushData() {
      this.tableData = utils.deepClone(this.tempModalSelection);
      this.recallForm.saleRecallPlanInfoVOS = [];
      this.tableData.forEach((item) => {
        this.recallForm.saleRecallPlanInfoVOS.push(
          {
            'saleRecallPlanInfo.revokedType': item.revokedTypeEnum,
            'saleRecallPlanInfo.recallItemId': item.itemId,
            'saleRecallPlanInfo.revokingCount': item.itemCount,
            'saleRecallPlanInfo.id': item.id,
            'saleRecallPlanInfo.goodsBatchNumber': item.goodsBatchNumber,
          },
        );
      });
      if (this.tableData && this.tableData.length > 0) {
        this.recallForm.saleRecallPlan.drugApprovedNames = this.tableData[0].drugApprovedNames; // 通用名称
        this.recallForm.saleRecallPlan.drugSerialCode = this.tableData[0].drugSerialCode; // 商品编码
        this.recallForm.saleRecallPlan.specifications = this.tableData[0].specifications; // 规格
        this.recallForm.saleRecallPlan.licenseNumber = this.tableData[0].goodsBatchNumber; // 批准文号
        this.recallForm.saleRecallPlan.manufacturer = this.tableData[0].manufacturer; // 生产企业
        this.recallForm.saleRecallPlan.goodsStoreId = this.tableData[0].goodsStoreId; // 商品id
        // this.tempGoodsStoreId = this.tableData[0].goodsStoreId;
      }
      this.hideModal();
    },

    handlePage(val) {
      this.page = val;
      this.getRecallGoods();
    },
    handleSize(val) {
      this.size = val;
      this.getRecallGoods();
    },
    handleSearch() {
      this.page = 1;
      this.getRecallGoods();
    },
    getInfos(id) {
      return new Promise((resolve) => {
        afterSale.recallPlanInfo({ id }).then((res) => {
          // console.log(res);
          if (res.data.status === 200) {
            const temp = Object.assign({}, res.data.data);

            this.id = temp.saleRecallPlan.recallPlanCode;
            let statusText = '';
            if (temp.saleRecallPlan.recallPlanStatus === 1) {
              statusText = '草稿';
            } else if (temp.saleRecallPlan.recallPlanStatus === 2) {
              statusText = '审批中';
            } else if (temp.saleRecallPlan.recallPlanStatus === 3) {
              statusText = '审批通过';
            } else if (temp.saleRecallPlan.recallPlanStatus === 4) {
              statusText = '驳回';
            } else if (temp.saleRecallPlan.recallPlanStatus === 5) {
              statusText = '已完成';
            }
            // recallPlanStatus
            this.infosArr.push(
              { name: '召回门店:', value: temp.saleRecallPlan.storeName },
              { name: '召回时间:', value: utils.exchangeTimeToSecond(temp.saleRecallPlan.modifiedTime) },
              { name: '召回人:', value: temp.saleRecallPlan.createUserName },
              { name: '单据状态:', value: statusText },
            );

            this.recallPlanStatus = temp.saleRecallPlan.recallPlanStatus; // 召回状态
            this.recallForm.saleRecallPlan = {
              id: temp.saleRecallPlan.id, // 召回计划id
              recallReason: temp.saleRecallPlan.recallReason, // 召回原因
              recallAgency: temp.saleRecallPlan.recallAgency, // 召回机构
              drugApprovedNames: temp.saleRecallPlan.drugApprovedNames, // 通用名称
              recallImgUrl: temp.saleRecallPlan.recallImgUrl, //商品图片
              drugSerialCode: temp.saleRecallPlan.drugSerialCode, // 商品编码
              specifications: temp.saleRecallPlan.specifications, // 规格
              licenseNumber: temp.saleRecallPlan.licenseNumber, // 批准文号
              manufacturer: temp.saleRecallPlan.manufacturer, // 生产企业
              supplierStoreId: temp.saleRecallPlan.supplierStoreId, // 供应商id
              goodsStoreId: temp.saleRecallPlan.goodsStoreId,
            };
            this.recallForm.saleRecallPlanInfoVOS = temp.saleRecallPlanInfoVOS;
            this.tempGoodsStoreId = this.recallForm.saleRecallPlan.goodsStoreId;

            if (temp.saleRecallPlanInfoVOS && temp.saleRecallPlanInfoVOS.length > 0) {
              const tempLicenseNumber = temp.saleRecallPlan.licenseNumber.split(',');
              temp.saleRecallPlanInfoVOS.forEach((item, index) => {
                this.tableData.push({
                  drugApprovedNames: temp.saleRecallPlan.drugApprovedNames,
                  goodsBatchNumber: tempLicenseNumber[tempLicenseNumber.length - 1 - index],
                  itemCount: item.saleRecallPlanInfo.revokingCount,
                  itemId: item.saleRecallPlanInfo.recallItemId,
                  manufacturer: temp.saleRecallPlan.manufacturer,
                  revokedTypeEnum: item.saleRecallPlanInfo.revokedType,
                  specifications: temp.saleRecallPlan.specifications,
                  recallPlanId: item.saleRecallPlanInfo.recallPlanId,
                  id: item.saleRecallPlanInfo.id,
                  goodsStoreId: temp.saleRecallPlan.goodsStoreId,
                });
                this.selectedIds.push(item.saleRecallPlanInfo.recallItemId);
              });
            }
          } else {
            this.$Message.error(res.data.error);
          }
          resolve();
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    getWorkFlow(id) {
      afterSale.recallWorkflow({ id }).then((res) => {
        if (res.data.status === 200) {
          console.log('查看审批中的召回详情');
          console.log(res.data);
        }
      });
    },
    handleLog() {
      // this.logParams.page = this.logPage;
      // this.logParams.size = this.logSize;
      // this.logParams.recallPlanId = this.tableData[0].recallPlanId;
      // const params = Object.assign({}, this.logParams);
      afterSale.recallPlanOperationList({ recallPlanId: this.$route.params.id }).then((res) => {
        if (res.data.status === 200) {
          this.logData = utils.deepClone(res.data.data);

          // this.logData = res.data.data.list;
          // console.log(this.logData)
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
      // recallOperateLog
    },
    selectDiffGoods() {
      this.goodsError = true;
      if (this.tableData && this.tableData.length > 0) {
        this.tempGoodsStoreId = this.tableData[0].goodsStoreId;
      }

      this.tableData.forEach((item) => {
        // console.log('--------------999999999------------');
        // console.log(item);
        // console.log(item.goodsStoreId+"-----------------"+this.tempGoodsStoreId)
        if (item.goodsStoreId !== this.tempGoodsStoreId) {
          this.goodsError = false;
        }
      });
    },
  },
  created() {
    if (this.$route.name !== 'medicineRecallAdd') {
      this.getInfos(this.$route.params.id).then(() => {
        if (this.$route.name === 'medicineRecallCheck') {
          for (let i = 0; i < this.columns.length; i++) {
            if (this.columns[i].key === 'addBtn') {
              this.columns.splice(i, 1);
              i--;
            }
          }
          if (this.recallPlanStatus === 2) {
            this.getWorkFlow(this.$route.params.id);
          }

          // if(this.recallPlanStatus === 3){
          //   this.columns.push(
          //     {title: '应召回数', key: 'revokingCount', minWidth: 116, fixed: 'right',},
          //     {
          //       title: '实际召回数', key: 'revokedCount', minWidth: 116, fixed: 'right',
          //       render: (h, params) => h('lk-input', {
          //         props: {
          //           clearable: true,
          //           value: params.row.revokedCount,
          //         },
          //         on: {
          //           'on-blur': (e) => {
          //             this.tableData[params.row._index].revokedCount = e.target.value;
          //           },
          //         },
          //       }),
          //     },
          //     {title: '未召回数', key: 'unrevokedCount', minWidth: 116, fixed: 'right',},
          //     {
          //       title: '备注', key: 'unrevokedReason ', minWidth: 116, fixed: 'right',
          //       render: (h, params) => h('lk-input', {
          //         props: {
          //           clearable: true,
          //           value: params.row.unrevokedReason,
          //         },
          //         on: {
          //           'on-blur': (e) => {
          //             this.tableData[params.row._index].unrevokedReason = e.target.value;
          //           },
          //         },
          //       }),
          //     }
          //   );
          // }
        }
      });
    }
    if (this.$route.name === 'medicineRecallCheck' || this.$route.name === 'medicineRecallRecordEdit' || this.$route.name === 'medicineRecallRecordCheck') {
      this.logText = '操作日志';
    }
  },
};
</script>

<style scoped lang="less">
  .goodsTable{
    overflow: auto;
    // border: 1px solid #eee;
    table{
      width: 100%;
      border-collapse: collapse;
      border: 1px solid #eee;

      // tr{
      //   height: 46px
      // }
      td{
        border: 1px solid #dedede;
        min-width: 110px;
        padding: 0 13px;

      }
      thead{
        background: #fafafa;
        font-weight: 500
      }
    }
    .detail{
      background: #F5F5F5;
      padding: 12px 24px;
      >td{
        padding-right: 0;
        >div{

          display: flex;
          flex-wrap: wrap
        }
      }
      .detailItem{
        margin-right: 30px
      }
    }
  }
  .modalQuery{
    display: flex;
    label{
      width: 60px;
      line-height: 32px;
      font-size: 14px;
      color: rgba(0,0,0,0.75);
    }
  }
</style>
